<template>
    <div class="block-text">
    
        <b-button :id="buttonID" :variant="btn_variant" :class="buttonStyle" @click="do_print">
            <i class="fa fa-print"></i>
            <span v-if="btn_text != undefined">{{ btn_text }}</span>
            <span v-else>{{ $t('menu.copy') }}</span>
        </b-button>

        <b-tooltip v-if="show_tooltip" :target="buttonID" placement="top">
            <span v-if="tooltip_text != undefined">{{ tooltip_text }}</span>
            <span v-else>{{ $t('menu.copy_to_clipboard') }}</span>
        </b-tooltip>

        <!-- <div v-if="ScreenShot_URL">
            <img :src="ScreenShot_URL" class="screenshot-preview">
        </div> -->
    </div>
</template>

<script>
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'

export default {
    props: {
        btn_variant: {
            type: String,
            default: 'warning',
        },
        btn_style: {
            type: String,
            default: ''
        },
        btn_text: {
            type: String,
            default: undefined,
        },
        tooltip_text: {
            type: String,
            default: undefined,
        },
        show_tooltip: {
            type: Boolean,
            default: true,
        },
        // save_type: {
        //     type: String,
        //     default: 'Image',
        // },
        // save_id: {
        //     type: String,
        //     default: 'app-printer' //'app-container',
        // },
        // save_filename: {
        //     type: String,
        //     default: 'download',
        // },
        // save_url: {
        //     type: String,
        //     default: undefined,
        // },
    },
    data () {
        return {
        }
    },
    mounted ()
    {
    },
    computed: {

        buttonID ()
        {
            return 'copy-button-' + this.copy_content + '-' + this.btn_text
        },

        buttonStyle ()
        {
            let _class = 'btn'
            switch ( this.btn_style )
            {
                case 'small':   _class += ' small'; break;
                case 'big':     _class += ' big'; break;
                case undefined: break;
                default:        _class += ' ' + this.btn_style; break;
            }
            
            return _class
        },

    },
    methods: {

        do_print ()
        {
            
            // 處理前，將有 class name = 'print-hide-object' ( 不需要匯出的工具 ) 項目加上 'print-hidden' 隱藏
            const _hiddenElements = document.getElementsByClassName('print-hide-object');
            if ( _hiddenElements && _hiddenElements.length > 0 )
            {
                for (let i=0; i<_hiddenElements.length; i++)
                {
                    _hiddenElements[i].classList.add('print-hidden')
                }
            }

            window.print()
                
            // 處理結束，將有 class name = 'print-hide-object' ( 不需要匯出的工具 ) 項目移除 'print-hidden' 回復原始狀態
            if ( _hiddenElements && _hiddenElements.length > 0 )
            {
                for (let i=0; i<_hiddenElements.length; i++)
                {
                    _hiddenElements[i].classList.remove('print-hidden')
                }
            }
        },
        
        
    }
}
</script>

<style lang="scss" scoped>

    .small
    {
        font-size: 0.85rem;
        padding: 2px 5px;
        
        i
        {
            margin-right: 0px;
        }
    }
    .big
    {
        font-size: 1.2rem;
        padding: 8px 15px;
    }

    .screenshot-preview
    {
        max-height: 200px;
    }

</style>
